import { useEffect, useRef, useState } from "react";

const useIntersectionObserver = (options = {}) => {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const [hasIntersected, setHasIntersected] = useState(false);
    const ref = useRef(null);

    const { threshold = 0.02, rootMargin = "0px", triggerOnce = true, ...otherOptions } = options;

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                const isElementIntersecting = entry.isIntersecting;
                setIsIntersecting(isElementIntersecting);

                if (isElementIntersecting && !hasIntersected) {
                    setHasIntersected(true);

                    // If triggerOnce is true, stop observing after first intersection
                    if (triggerOnce) {
                        observer.unobserve(element);
                    }
                }
            },
            {
                threshold,
                rootMargin,
                ...otherOptions,
            }
        );

        observer.observe(element);

        return () => {
            observer.unobserve(element);
        };
    }, [threshold, rootMargin, hasIntersected, triggerOnce, ...Object.values(otherOptions)]);

    return [ref, isIntersecting, hasIntersected];
};

export default useIntersectionObserver;
